import { Component, Input, ViewChild, Type, ComponentFactoryResolver } from '@angular/core';
import { CellHolderDirective } from './cell-holder.directive';
import { Col } from '../../utility/cols/col.class';
import { AbstractTable } from '../../utility/context/abstract/table.class';
import { ghost } from '../../../animations/animations';

// ================= Component =================
@Component({
   selector: 'exi-header-cell',
   template: `
      <ng-template cell-holder></ng-template>
      <!-- ------------------- Sizer ------------------- -->
      <div  [ngStyle]="{ 'height.px': ctx.dom.wrapper?.offsetHeight - 15 }"
            *ngIf="!col.isPinned"
            (mousedown)="ctx.sizer.onMouseDown($event, col)"
            class="sizer" ></div>
      <div  *ngIf="ctx.dragger.isDragging && col.isPinned && col === ctx.cols.lastPinned" 
            [ngStyle]="{ 'height.px': ctx.dom.wrapper?.offsetHeight }"
            class="pin-line"
            @ghost></div>
   `,
   styleUrls: ['./header-cell.styles.scss'],
   animations: [ ghost ]
})
export class TableHeaderCellHolderComponent {
   @ViewChild(CellHolderDirective) private cellHolder: CellHolderDirective;
   @Input('col') public set colChanges(col: Col<object>) {
      this.col = col;
      this.ctx = col.ctx;
      this.createCell(col);
   }
   public col: Col<object>;
   public ctx: AbstractTable<object>;

   constructor(
      private cmpResolver: ComponentFactoryResolver
   ) { }

   createCell(col: Col<object>) {
      const factory = this.cmpResolver.resolveComponentFactory(col.component);
      const viewRef = this.cellHolder.viewContainerRef;
      const instance = viewRef.createComponent(factory).instance;
      instance.col = col;
   }
}
// ================= Models =================
export type HeaderCell = Type<IHeaderCell>;

export interface IHeaderCell {
   col: Col<object>;
}